import styled from "styled-components";
import { mediaQuery } from "oolib";

export const StyledWrapper = styled.div`
  display: flex;
  user-select: none;
  flex-direction: column;

  ${mediaQuery('md')}{
    flex-direction: row;
  }
`
